import {Truncate} from '@dropbox/dig-components/truncate';
import {Text} from '@dropbox/dig-components/typography';
import {PersonLine} from '@dropbox/dig-icons/assets';
import cx from 'classnames';
import {Avatar, AvatarIcon} from 'components/DSYS/Avatar';
import {PersonHoverCard} from 'components/DSYS/HoverCard';
import {Link} from 'components/DSYS/Link';
import {ROUTE_PATHS} from 'constant';

import styles from './Roadmap.module.css';

export interface RoadmapPersonValue {
  name?: string | null;
  ldap?: string | null;
  role?: string | null;
  profilePhotoUrl?: string | null;
}

export const RoadmapPerson = ({
  person,
  emptyLabel = '—',
}: {
  person?: RoadmapPersonValue | null;
  emptyLabel?: string;
}) => {
  const ldap = person?.ldap?.trim() || null;
  const name = person?.name?.trim() || ldap;

  if (!name) {
    return (
      <Text size="small" color="subtle" className={styles.roadmapMetaText}>
        {emptyLabel}
      </Text>
    );
  }

  const content = (
    <>
      <span
        className={styles.roadmapPersonAvatar}
        aria-hidden="true"
        data-roadmap-person-avatar={ldap ? 'employee' : 'jira'}
      >
        {ldap ? (
          <Avatar user={{name, ldap, profile_photo_url: person?.profilePhotoUrl}} size="xsmall" />
        ) : (
          <AvatarIcon src={PersonLine} size="small" iconSize="small" />
        )}
      </span>
      <Text size="small" className={cx(styles.roadmapMetaText, styles.roadmapPersonName)}>
        <Truncate lines={1} tooltipControlProps={{placement: 'top-start'}}>
          {name}
        </Truncate>
      </Text>
    </>
  );

  if (!ldap) {
    return <span className={styles.roadmapPersonContent}>{content}</span>;
  }

  return (
    <PersonHoverCard
      ldap={ldap}
      name={name}
      role={person?.role}
      profilePhotoUrl={person?.profilePhotoUrl}
    >
      <Link
        to={ROUTE_PATHS.PROFILE.replace(':userid', ldap)}
        hasNoUnderline
        monochromatic
        className={styles.roadmapPersonContent}
      >
        {content}
      </Link>
    </PersonHoverCard>
  );
};
